import { EventsPreset, RetargetingAudianceEnum } from "../enums";

export const mapProductAudienceSpec: any = {
    [EventsPreset.ViewOrAddToCartButNotPurchase]: RetargetingAudianceEnum.VIEWED_OR_ADDED,
    [EventsPreset.AddToCartButNotPurchase]: RetargetingAudianceEnum.ADDED,
    [EventsPreset.Upsell]: RetargetingAudianceEnum.UPSELL_PRODUCTS,
    [EventsPreset.CrossSell]: RetargetingAudianceEnum.CROSS_SELL_PRODUCTS,
    [EventsPreset.Custom]: RetargetingAudianceEnum.CUSTOM,
}